import {apiClient} from "@/state/modules/apiClient";
const controller = "users";

export const state = {
    reloadAuthUser: false,
}

export const mutations = {
    SET_RELOADAUTHUSER(state, newValue) {
        state.reloadAuthUser = newValue
    }
}
export const actions = {
    async getAll({commit}) {
        return apiClient.get(controller + "/get-all");
    },
    async getKyThay({commit}) {
        return apiClient.get(controller + "/get-kythay");
    },
    async getUsersLanhDao({commit}) {
        return apiClient.get(controller + "/get-users-lanhdao");
    },
    async userTreeForDonVi({commit}) {
        return apiClient.get(controller + "/get-user-tree-for-donvi");
    },
    async changePassword({commit}, params) {
        return apiClient.post(controller + "/change-password",params);
    },
    async getPagingParams({commit}, params) {
        return apiClient.post(controller +"/get-paging-params", params);
    },
  async getPagingParamsMembers({commit}, params) {
    return apiClient.post(controller +"/get-paging-params-members", params);
  },
  async getPagingParamsMembersProject({commit}, params) {
    return apiClient.post(controller +"/get-paging-params-members-project", params);
  },
    async create({commit}, values) {
        return apiClient.post(controller +"/create", values);
    },
    async update({commit, dispatch}, values) {
        return apiClient.put(controller +"/update", values);
    },
    async delete({commit}, id) {
        return await apiClient.delete(controller +"/delete/" + id);
    },
    async getById({commit}, id) {
        return apiClient.get(controller +"/get-by-id/" + id);
    },
    async changeProfile({commit, dispatch}, values) {
        return apiClient.put(controller + "/change-profile", values);
    },
    async updateSignature({commit, dispatch}, values) {
        return apiClient.post(controller + "/update-signature", values);
    },
    async getSignature({commit, dispatch}, userName) {
        return apiClient.get(controller + "/get-signature/" + userName);
    },
    async createKyThay({commit}, values) {
        return apiClient.post(controller +"/create-kythay", values);
    },
    async updateKyThay({commit, dispatch}, values) {
        return apiClient.put(controller +"/update-kythay", values);
    },
    async deleteKyThay({commit}, id) {
        return await apiClient.delete(controller +"/delete-kythay/" + id);
    },
    async getPagingParamsKyThay({commit}, params) {
        return apiClient.post(controller +"/get-paging-params-kythay", params);
    },
    async getByIdKyThay({commit}, id) {
        return apiClient.get(controller +"/get-by-id-kythay/" + id);
    },
    async unblockAccount({commit}, id){
        return apiClient.post(controller + "/unblock-account/" + id, null)
    },
    async resetPassword({commit, dispatch}, values) {
        return apiClient.post(controller + "/reset-password", values);
    },
};
